{
  "schedule": "Schedule Monitor",
  "comm": "Comm Monitor",
  "webrtcStats": "WebRTC Stats",
  "webrtc": "Web Phone",
  "host": "Host Resource",
  "docs": "User Manual"
}
